import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import VueCookie from 'vue-cookie'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home'),
    meta: { requiresAuth: true },
  },

  {
    path: '/en',
    name: 'home',
    component: () => import('../views/Home'),
    meta: { requiresAuth: true },
  },

  // ---------------Errors-------------------
  {
    path: '/no-access',
    name: 'noAccess',
    component: () => import('../views/NoAccess'),
  },
  {
    path: '*',
    name: 'notfound',
    component: () => import('../views/NotFound'),
  },
]

const router = new VueRouter({
  mode: 'history', //убрать хеш из урла
  routes
})

router.beforeEach((to, from, next) => {

  // const needsAuth = to.matched.some((record) => record.meta.requiresAuth)
  // const needsAdmin = to.matched.some((record) => record.meta.requiresAdmin)
  // const authBlocked = to.matched.some((record) => record.meta.authBlocked)
  // let isAuthenticated = store.state.authentication.isAuthenticated
  // const isCookieAuthed = VueCookie.get('authenticated') === 'true'

  // if (isCookieAuthed && !isAuthenticated) {
  //   // need to set auth state if getting here from auth cookie
  //   const data = JSON.parse(localStorage.getItem('user'))
  //   store.commit('user/set', data.user)
  //   store.commit('authentication/set', {
  //     authenticated: true,
  //     token: data.token,
  //   })
  //   isAuthenticated = true
  // }

  // if (authBlocked) {
  //   if (isAuthenticated) {
  //     next('/')
  //     return
  //   }
  // }

  // if (needsAuth) {
  //   if (isAuthenticated) {
  //     if (needsAdmin) {
  //       if (store.getters['user/isAdmin']) {
  //         next()
  //         return
  //       } else {
  //         next('/no-access')
  //         return
  //       }
  //     }
  //     // if (store.getters['user/isSubscriptionExpired']) {
  //     //   await authService.logout()
  //     //   next({
  //     //     path: '/login',
  //     //     query: {
  //     //       info: 'Your subscription has expired. Please contact support',
  //     //     },
  //     //   })
  //     //   return
  //     // }
  //     next()
  //     return
  //   }
  //   next('/login')
  //   return
  // } else {
  //   next()
  // }

  next()
});

router.afterEach((to, from) => {

});

export default router
